// extracted by mini-css-extract-plugin
export var noSpinners = "_q4-6";
export var percentageInput = "_q4-7";
export var variantColor1 = "_q4-0";
export var variantColor2 = "_q4-1";
export var variantColor3 = "_q4-2";
export var variantColor4 = "_q4-3";
export var variantColor5 = "_q4-4";
export var variantColor6 = "_q4-5";